import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

// Outlined building from the Practice search Figma (find-care practice cards).
// Drawn on a 16px grid, unlike most system icons.
export const Building = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="building icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.33333 2C5.15652 2 4.98695 2.07024 4.86193 2.19526C4.7369 2.32029 4.66667 2.48986 4.66667 2.66667V14H11.3333V2.66667C11.3333 2.48986 11.2631 2.32029 11.1381 2.19526C11.013 2.07024 10.8435 2 10.6667 2H5.33333ZM3.91912 1.25245C4.29419 0.87738 4.8029 0.666667 5.33333 0.666667H10.6667C11.1971 0.666667 11.7058 0.87738 12.0809 1.25245C12.456 1.62753 12.6667 2.13623 12.6667 2.66667V14.6667C12.6667 15.0349 12.3682 15.3333 12 15.3333H4C3.63181 15.3333 3.33333 15.0349 3.33333 14.6667V2.66667C3.33333 2.13623 3.54405 1.62753 3.91912 1.25245Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.25245 7.91912C1.62753 7.54405 2.13623 7.33333 2.66667 7.33333H4C4.36819 7.33333 4.66667 7.63181 4.66667 8C4.66667 8.36819 4.36819 8.66667 4 8.66667H2.66667C2.48986 8.66667 2.32029 8.7369 2.19526 8.86193C2.07024 8.98695 2 9.15652 2 9.33333V13.3333C2 13.5101 2.07024 13.6797 2.19526 13.8047C2.32029 13.9298 2.48986 14 2.66667 14H4C4.36819 14 4.66667 14.2985 4.66667 14.6667C4.66667 15.0349 4.36819 15.3333 4 15.3333H2.66667C2.13623 15.3333 1.62753 15.1226 1.25245 14.7475C0.87738 14.3725 0.666667 13.8638 0.666667 13.3333V9.33333C0.666667 8.8029 0.87738 8.29419 1.25245 7.91912Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3333 6C11.3333 5.63181 11.6318 5.33333 12 5.33333H13.3333C13.8638 5.33333 14.3725 5.54405 14.7475 5.91912C15.1226 6.29419 15.3333 6.8029 15.3333 7.33333V13.3333C15.3333 13.8638 15.1226 14.3725 14.7475 14.7475C14.3725 15.1226 13.8638 15.3333 13.3333 15.3333H12C11.6318 15.3333 11.3333 15.0349 11.3333 14.6667C11.3333 14.2985 11.6318 14 12 14H13.3333C13.5101 14 13.6797 13.9298 13.8047 13.8047C13.9298 13.6797 14 13.5101 14 13.3333V7.33333C14 7.15652 13.9298 6.98695 13.8047 6.86193C13.6797 6.7369 13.5101 6.66667 13.3333 6.66667H12C11.6318 6.66667 11.3333 6.36819 11.3333 6Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 4C6 3.63181 6.29848 3.33333 6.66667 3.33333H9.33333C9.70152 3.33333 10 3.63181 10 4C10 4.36819 9.70152 4.66667 9.33333 4.66667H6.66667C6.29848 4.66667 6 4.36819 6 4Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 6.66667C6 6.29848 6.29848 6 6.66667 6H9.33333C9.70152 6 10 6.29848 10 6.66667C10 7.03486 9.70152 7.33333 9.33333 7.33333H6.66667C6.29848 7.33333 6 7.03486 6 6.66667Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 9.33333C6 8.96514 6.29848 8.66667 6.66667 8.66667H9.33333C9.70152 8.66667 10 8.96514 10 9.33333C10 9.70152 9.70152 10 9.33333 10H6.66667C6.29848 10 6 9.70152 6 9.33333Z"
    />
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 12C6 11.6318 6.29848 11.3333 6.66667 11.3333H9.33333C9.70152 11.3333 10 11.6318 10 12C10 12.3682 9.70152 12.6667 9.33333 12.6667H6.66667C6.29848 12.6667 6 12.3682 6 12Z"
    />
  </svg>
)
